import { useEffect, useRef, useState } from 'react';
import { adminApi, type AdminPhoto } from '../../lib/api';
import { SortableList } from './SortableList';
import { Field, Modal } from './LiveAdminPanel';

export default function PhotoAdminPanel() {
  const [items, setItems] = useState<AdminPhoto[]>([]);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState<AdminPhoto | null>(null);
  const fileInput = useRef<HTMLInputElement>(null);

  async function reload() {
    setLoading(true);
    setItems(await adminApi.photoList());
    setLoading(false);
  }
  useEffect(() => { reload(); }, []);

  async function upload(files: FileList | null) {
    if (!files || files.length === 0) return;
    for (const file of Array.from(files)) {
      const fd = new FormData();
      fd.append('image', file);
      fd.append('caption', '');
      fd.append('is_active', 'true');
      await adminApi.photoCreate(fd);
    }
    reload();
  }

  async function reorder(next: AdminPhoto[]) {
    setItems(next);
    await adminApi.photoReorder(next.map((i) => i.id));
  }

  async function remove(id: number) {
    if (!confirm('Eliminare questa foto?')) return;
    await adminApi.photoDelete(id);
    reload();
  }

  async function saveMeta() {
    if (!editing) return;
    await adminApi.photoUpdate(editing.id, {
      caption: editing.caption,
      is_featured: editing.is_featured,
      is_active: editing.is_active,
    });
    setEditing(null);
    reload();
  }

  return (
    <section className="admin-panel">
      <div className="admin-panel-head">
        <h2>Foto</h2>
        <div>
          <input
            ref={fileInput}
            type="file"
            accept="image/*"
            multiple
            style={{ display: 'none' }}
            onChange={(e) => { upload(e.target.files); e.target.value = ''; }}
          />
          <button className="btn-primary" onClick={() => fileInput.current?.click()}>+ Carica foto</button>
        </div>
      </div>

      {loading && <p className="muted">Caricamento...</p>}
      {!loading && items.length === 0 && <p className="muted">Nessuna foto.</p>}

      <SortableList
        items={items}
        onReorder={reorder}
        renderItem={(item, handle) => (
          <div className="admin-row admin-row-photo">
            {handle}
            <img src={item.image} alt="" className="admin-thumb" />
            <div className="admin-row-main">
              <div className="admin-row-title">
                {item.caption || <span className="muted">— senza didascalia —</span>}
                {item.is_featured && <span className="badge-amber">In evidenza</span>}
                {!item.is_active && <span className="badge-muted">nascosta</span>}
              </div>
            </div>
            <div className="admin-row-actions">
              <button className="btn-ghost" onClick={() => setEditing(item)}>Modifica</button>
              <button className="btn-danger" onClick={() => remove(item.id)}>Elimina</button>
            </div>
          </div>
        )}
      />

      {editing && (
        <Modal title="Modifica foto" onClose={() => setEditing(null)}>
          <img src={editing.image} alt="" style={{ maxWidth: '100%', borderRadius: 8, marginBottom: 12 }} />
          <Field label="Didascalia">
            <input value={editing.caption || ''} onChange={(e) => setEditing({ ...editing, caption: e.target.value })} />
          </Field>
          <Field label="In evidenza">
            <input type="checkbox" checked={editing.is_featured} onChange={(e) => setEditing({ ...editing, is_featured: e.target.checked })} />
          </Field>
          <Field label="Visibile">
            <input type="checkbox" checked={editing.is_active} onChange={(e) => setEditing({ ...editing, is_active: e.target.checked })} />
          </Field>
          <div className="modal-actions">
            <button className="btn-ghost" onClick={() => setEditing(null)}>Annulla</button>
            <button className="btn-primary" onClick={saveMeta}>Salva</button>
          </div>
        </Modal>
      )}
    </section>
  );
}
